module.exports = __webpack_public_path__ + "static/media/DSC_0332.ced6d07b.JPG";